// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import {
  BridgeAgreement,
  BridgeAgreementOffer,
} from '@daml.js/utility-bridge-v0/lib/Utility/Bridge/V0/Agreement/Bridge';
import { NonceConfiguration } from '@daml.js/utility-bridge-v0/lib/Utility/Bridge/V0/Nonce/Nonce';
import { BridgeConfiguration } from '@daml.js/utility-bridge-v0/lib/Utility/Bridge/V0/Util/module';
import { ContractId } from '@daml/types';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';

const useAcceptBridgeAgreement: () => UseMutationResult<
  ContractId<BridgeAgreement>,
  string,
  {
    bridgeAgreementOfferCid: ContractId<BridgeAgreementOffer>;
    nonceConfig: NonceConfiguration;
    bridgeConfig: BridgeConfiguration;
    withdrawalAttester: string;
  }
> = () => {
  const ledgerApi = useLedgerApiClient();

  return useMutation({
    mutationKey: ['acceptBridgeAgreementOffer', ledgerApi],
    mutationFn: async ({
      bridgeAgreementOfferCid,
      nonceConfig,
      bridgeConfig,
      withdrawalAttester,
    }) => {
      return ledgerApi.acceptBridgeAgreementOffer(
        bridgeAgreementOfferCid,
        nonceConfig,
        bridgeConfig,
        withdrawalAttester,
      );
    },
  });
};

export default useAcceptBridgeAgreement;
